<template>
  <v-sheet class="cardDashboard pa-8" color="transparent" height="750">
    <l-map
        ref="mapRef"
        class="mapClassBorder"
        :style="'border: 4px solid white'"
        :zoom="zoomMap" 
        :center="centerMap"
        @ready="onMapReady"
        :options="{ zoomControl: false}">
            <l-control-zoom :position="'topleft'"  ></l-control-zoom>
            <l-tile-layer :url="finalURL"></l-tile-layer>
            
        </l-map>
  </v-sheet>
</template>

<script setup lang="ts">
import axios from 'axios';
import { computed, onMounted, Ref, ref } from 'vue';
import { APIS_IA } from '@/constants/apis';
import { TOKEN } from '@/constants/labels';
import CONSTMAPS from '@/constants/maps';
import CONSTAPIS from '@/constants/apis';

/********************************
 *********** LEAFTLET ***********
 *******************************/
import { LMap, LControlZoom,LTileLayer } from "@vue-leaflet/vue-leaflet";
import "/public/leaflet/leaflet.css";
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const zoomMap = computed( () => CONSTMAPS.zoom.value);
const centerMap:Ref<any> = ref([CONSTMAPS.latitud.value,CONSTMAPS.longitud.value])
const finalURL = 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
    
const mapInstance:any = ref(null);

// Esta función se dispara cuando Leaflet termina de cargar
const onMapReady = (mapObject:any) => {
 // Guardamos la instancia del mapa para usarla con Javascript puro
  mapInstance.value = mapObject;
}

function getAllInfo() {
    axios.get(APIS_IA.value.getClusteringDataTransform, {
        headers: {
            'Authorization': `Bearer ${TOKEN}`
        }   
    }).then((response) => {
        const data = response.data;

        L.geoJSON(data, {
      // ESTILO: Aquí ocurre la magia visual
      style: (feature:any) => {
        return {
          color: 'white',        // Borde blanco fino entre hexágonos
          weight: 1,             // Grosor del borde
          fillColor: feature.properties.color, // <--- EL COLOR QUE VIENE DEL BACKEND
          fillOpacity: 0.6       // Transparencia para ver el terreno debajo
        };
      },
      // INTERACCIÓN: Popup al hacer click
      onEachFeature: (feature, layer) => {
        const p = feature.properties;
        const popupContent = `
          <div style="text-align:center">
            <h3 style="margin:0; color:${p.color}">Zona ${p.tasaFallo} Fallo</h3>
            <hr style="margin:5px 0">
            <b>Muestras:</b> ${p.muestras}<br>
            <b>Fallos:</b> ${p.fallos}<br>
            </div>
            `;
            // <small>ID: ${p.h3Id}</small>
        layer.bindPopup(popupContent);
      }
    }).addTo(mapInstance.value);
        console.log(data);
    }).catch((error) => {
        console.error('Error fetching data:', error);
    });
}



onMounted(() => {
    getAllInfo();
});

</script>
